import { BsCheckSquare } from "react-icons/bs";
import { GoLocation } from "react-icons/go";
import Moment from "react-moment";
import { Table } from "antd";
import LoadingIcon from "../../../../components/shared/LoadingIcon";
import { useEffect, useState } from "react";

export default function WallBookings({ bookings, isLoading }: any) {
  let columns = [
    {
      title: "S/N",
      width: 50,
      dataIndex: "",
      render: (record: any, text: any, index: any) => (
        <span className="text-gray-700 ml-2">{index + 1}</span>
      ),
    },
    {
      title: "Customer",
      width: 150,
      dataIndex: "",
      render: (record: any) => (
        <div className="w-full">
          {record?.customer_code === 0 ? (
            <div className="text-gray-700 bg-red-200 px-2 py-1 w-full">
              <span className="mr-2"> Guest:</span>
              {record?.customer_name === null ? "-" : record?.customer_name}
            </div>
          ) : (
            <div className="px-2 py-1">
              {record?.customer_name === null ? "-" : record?.customer_name}
            </div>
          )}
        </div>
      ),
    },
    {
      title: "Requested",
      width: 90,
      dataIndex: "",
      render: (record: any) => (
        <span className="text-gray-700">
          {record?.createdAt === null ? (
            "-"
          ) : (
            <Moment fromNow>{record?.createdAt}</Moment>
          )}
        </span>
      ),
    },
    {
      title: "Vehicle",
      width: 80,
      dataIndex: "",
      render: (record: any) => (
        <div className="flex flex-col">
          <span className="text-gray-700">
            {record?.vehicle === null ? "-" : record?.vehicle}
          </span>
        </div>
      ),
    },
    {
      title: "Model",
      width: 100,
      dataIndex: "",
      render: (record: any) => (
        <span className="text-gray-700">
          {record?.model_year === null ? "" : record?.model_year}{" "}
          {record?.model === null ? "-" : record?.model}
        </span>
      ),
    },
    {
      title: "Date",
      width: 100,
      dataIndex: "",
      render: (record: any) => (
        <span className="text-gray-700">
          {record?.date === undefined || record?.date === null ? (
            "-"
          ) : (
            <>
              <Moment format="Do MMM, YYYY">{record?.date}</Moment>
            </>
          )}
        </span>
      ),
    },

    {
      title: "Time",
      width: 140,
      dataIndex: "",
      render: (record: any) => (
        <span className="text-gray-700">
          {record?.date === undefined || record?.date === null ? (
            "-"
          ) : (
            <>
              {record?.slottime === null ? (
                "-"
              ) : (
                <>
                  <Moment format="HH:mm A">
                    {record?.slottime?.starttime}
                  </Moment>
                  <span className="mx-1">-</span>
                  <Moment format="HH:mm A">{record?.slottime?.endtime}</Moment>
                </>
              )}
            </>
          )}
        </span>
      ),
    },
    {
      title: "Booking No.",
      width: 100,
      dataIndex: "",
      render: (record: any) => (
        <div className="flex justify-center items-center text-gray-700">
          <span className="ml-1">
            {record?.bookingno ? record?.bookingno : "-"}
          </span>
        </div>
      ),
    },
    {
      title: "WIP",
      width: 60,
      dataIndex: "",
      render: (record: any) => (
        <div className="flex justify-center items-center text-gray-700">
          <span className="">{record?.wip ? record?.wip : "-"}</span>
        </div>
      ),
    },

    {
      title: "Advisor",
      width: 100,
      dataIndex: "",
      render: (record: any) => (
        <div className="flex items-center text-gray-700">
          <div className="ml-1 trancate">
            {record?.assignedTo
              ? `${record?.assignedTo?.firstname.charAt(0)}.${
                  record?.assignedTo?.lastname
                }`
              : "-"}
          </div>
        </div>
      ),
    },

    {
      title: "Location",
      width: 120,
      dataIndex: "",
      render: (record: any) => (
        <div className="flex truncate">
          <div className="flex justify-center items-center ml-1 text-blue-700 border rounded-md px-2 py-1 bg-blue-50 hover:bg-blue-50">
            <GoLocation /> <span className="ml-1">-</span>
          </div>
        </div>
      ),
    },
    {
      title: "Status",
      width: 70,
      dataIndex: "",
      render: (record: any) => (
        <div className="flex">
          {record.is_confirmed ? (
            <div className="bg-status-green font-bold px-2 py-1 rounded-md text-center text-white w-full flex items-center justify-center">
              <BsCheckSquare /> <span className="ml-1">CONFIRMED</span>
            </div>
          ) : (
            <div className="bg-status-red text-white font-bold px-2 py-1 rounded-md text-center w-full">
              <span>UNCONFIRMED</span>
            </div>
          )}
        </div>
      ),
    },
  ];

  function chunkArray(arr: any, chunkSize: any) {
    const result = [];
    for (let i = 0; i < arr.length; i += chunkSize) {
      result.push(arr.slice(i, i + chunkSize));
    }
    return result;
  }

  const data = chunkArray(bookings, 20);

  const [currentIndex, setCurrentIndex] = useState(0);

  const nextIndex = () => {
    const newIndex = (currentIndex + 1) % data?.length;
    setCurrentIndex(newIndex);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      nextIndex();
    }, 10000);

    return () => {
      clearInterval(interval);
    };
  }, [currentIndex]);

  if (isLoading) {
    return (
      <div className="flex justify-center bg-white">
        <LoadingIcon />
      </div>
    );
  }
  return (
    <div className="">
      <div className=" p-2 border-b border-gray-300 bg-red-100">
        BOOKING BATCH : {Number(currentIndex) + 1} / {data?.length}
      </div>
      <Table
        columns={columns}
        dataSource={data[currentIndex]}
        size="small"
        pagination={false}
        rowKey="id"
        loading={isLoading}
      />
    </div>
  );
}
